import React from 'react';

type DuplicateIconProps = {
  width?: number;
  height?: number;
  color?: string;
};

function DuplicateIcon({
  width = 20,
  height = 20,
  color = '#6267AC',
}: DuplicateIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.74996 1.66883C8.18742 1.67646 7.84971 1.70903 7.57664 1.84816C7.26304 2.00795 7.00807 2.26292 6.84828 2.57652C6.70915 2.84959 6.67658 3.1873 6.66896 3.74984M16.25 1.66883C16.8125 1.67646 17.1502 1.70903 17.4233 1.84816C17.7369 2.00795 17.9919 2.26292 18.1516 2.57652C18.2908 2.84958 18.3233 3.18729 18.331 3.74983M18.331 11.2498C18.3233 11.8124 18.2908 12.1501 18.1516 12.4232C17.9919 12.7368 17.7369 12.9917 17.4233 13.1515C17.1502 13.2906 16.8125 13.3232 16.25 13.3308M18.3333 6.6665V8.33317M11.6667 1.6665H13.3333M4.33329 18.3332H10.6666C11.6 18.3332 12.0668 18.3332 12.4233 18.1515C12.7369 17.9917 12.9918 17.7368 13.1516 17.4232C13.3333 17.0666 13.3333 16.5999 13.3333 15.6665V9.33317C13.3333 8.39975 13.3333 7.93304 13.1516 7.57652C12.9918 7.26292 12.7369 7.00795 12.4233 6.84816C12.0668 6.6665 11.6 6.6665 10.6666 6.6665H4.33329C3.39987 6.6665 2.93316 6.6665 2.57664 6.84816C2.26304 7.00795 2.00807 7.26292 1.84828 7.57652C1.66663 7.93304 1.66663 8.39975 1.66663 9.33317V15.6665C1.66663 16.5999 1.66663 17.0666 1.84828 17.4232C2.00807 17.7368 2.26304 17.9917 2.57664 18.1515C2.93316 18.3332 3.39987 18.3332 4.33329 18.3332Z'
        stroke={color}
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}

export default DuplicateIcon;
